import { newRelicManager } from "gather-browser-newrelic-manager/dist/src/public/newRelicManager";
import { MetricsEventName, } from "gather-http-common/dist/src/public/metrics/constants";
import { just } from "gather-common/dist/src/public/fpHelpers";
const SampledEvents = {
    [MetricsEventName.PRESS_Z_TO_DANCE]: 0,
    [MetricsEventName.USE_SCREENSHARE_CURSOR]: 0,
    [MetricsEventName.SET_EMOTE]: 0.2,
    [MetricsEventName.CALENDAR_CREATE_SPAWN_TILE_ID]: 0,
    [MetricsEventName.DELETE_OBJECT]: 0,
    [MetricsEventName.SHOOT_CONFETTI]: 0,
    [MetricsEventName.PLACE_OBJECT]: 0,
    [MetricsEventName.RW_WIZARD_OFFICE_CONFIGURATION_MAP_SWITCH]: 0,
    [MetricsEventName.RW_DESK_BUILD_SWITCH_OBJECT]: 0,
    [MetricsEventName.GUEST_EXPERIENCE_GUEST_PASS_REVOKED]: 0,
    [MetricsEventName.SPACE_DASHBOARD_TAB_VIEWED]: 0,
    [MetricsEventName.VIDEO_EFFECT_SELECTED]: 0,
    [MetricsEventName.EVENT__CHAT_SEND_MESSAGE]: 0,
    [MetricsEventName.CALENDAR_NUM_DISPLAYED_CALS]: 0,
    [MetricsEventName.MOBILE_APP_HOT_START]: 0,
    [MetricsEventName.SEND_FIRST_CHAT_TODAY]: 0,
    [MetricsEventName.SEND_CHAT_MESSAGE]: 0,
    [MetricsEventName.KICK_USER]: 0,
    [MetricsEventName.TIME_IN_MAP_VIEW_AND_CONNECTED]: 0,
    [MetricsEventName.INTERACT_WITH_OBJECT]: 0,
    [MetricsEventName.RW_DESK_BUILD_DRAG_OBJECT]: 0,
    [MetricsEventName.SPACE_CREATOR_ONBOARDING_STEP_VIEWED]: 0,
    [MetricsEventName.VIDEO_RESIZE_BUTTON]: 0,
    [MetricsEventName.MOBILE_APP_OPEN_SETTINGS]: 0,
    [MetricsEventName.SPACE_CREATOR_ONBOARDING_STEP_COMPLETED]: 0,
    [MetricsEventName.CLICKACTION_MOVE]: 0,
    [MetricsEventName.END_WHISPER]: 0,
    [MetricsEventName.COMPLETED_TUTORIAL_TASK]: 0,
    [MetricsEventName.MINIMODE_MOVE_WINDOW]: 0,
    [MetricsEventName.VIDEO_MODE_TOGGLE]: 0,
    [MetricsEventName.HAVE_SHORT_CONVO_VIDEO_REQ]: 0,
    [MetricsEventName.MINIMODE_CLICK_PLAYER_CARD]: 0,
    [MetricsEventName.WIZARD_PASSWORD_PROTECT_TOGGLED]: 0,
    [MetricsEventName.JOINING_WITH_SPAWN_TOKEN]: 0,
    [MetricsEventName.SPACE_CAPACITY_INFO_SHOWN_IN_GRAPES_MENU]: 0,
    [MetricsEventName.EVENT__SAVE_LANDING_PAGE]: 0,
    [MetricsEventName.MEETINGS_SELECTED_EXTENSION_SPACE]: 0.5,
    [MetricsEventName.START_WHISPER]: 0,
    [MetricsEventName.CLICKACTION_STARTBUBBLE]: 0,
    [MetricsEventName.ATTENDEE_OPEN_INFORMATION_BOARD]: 0,
    [MetricsEventName.VIDEO_MODE_SELECT]: 0.5,
    [MetricsEventName.CHANGE_STATUS]: 0,
    [MetricsEventName.INSIGHTS_CHART_RENDERED]: 0,
};
export const prefixNRKeys = (prefix, obj) => Object.entries(obj).reduce((acc, [key, value]) => ({
    ...acc,
    [`${prefix}.${key}`]: JSON.stringify(value),
}), {});
export const logMetricsEventToNewRelic = (eventName, eventProperties = {}) => {
    const properties = { ...eventProperties };
    if (eventName in SampledEvents) {
        const sampleRate = just(SampledEvents[eventName]);
        if (Math.random() > sampleRate)
            return;
        properties.sampleRate = sampleRate;
    }
    newRelicManager.addPageAction(`Product Event: ${eventName}`, properties);
};
//# sourceMappingURL=newrelic.js.map